module.exports = __webpack_public_path__ + "img/freestyle_box28.49882b36.jpg";